import toast from "react-hot-toast";
import customFetch from "../hooks/fetchWrapper";

// Create a new area
export const createBusDriver = async (formBody) => {
  return toast.promise(
    customFetch("insertDriverDetails", {
      method: "POST",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Creating area...",
      success: (data) => `${data.message}`,
      error: "Failed to create area",
    }
  );
};

export const createBulkBusDriver = async (formBody) => {
  return toast.promise(
    customFetch("insertDriverDetailsBulk", {
      method: "POST",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Creating bus drivers...",
      success: (data) => `${data.message}`,
      error: "Failed to create bus drivers",
    }
  );
};

export const deleteBusDriver = async (driverId) => {
  return toast.promise(
    customFetch(`deleteDriverdetails/${driverId}`, {
      method: "DELETE",
    }),
    {
      loading: "Deleting bus driver...",
      success: (data) => `${data.message}`,
      error: "Failed to delete bus driver",
    }
  );
};

export const deleteAllBusDriver = async (driverId) => {
  return toast.promise(
    customFetch(`deleteAllDrivers`, {
      method: "DELETE",
    }),
    {
      loading: "Deleting bus driver...",
      success: (data) => `${data.message}`,
      error: "Failed to delete bus driver",
    }
  );
};

export const updateBusDriver = async (driverData) => {
  console.log("🚀 ~ updateBusDriver ~ driverData:", driverData);

  // Extract the DriverID for the URL path but keep full data for body
  const { DriverID } = driverData;

  return toast.promise(
    customFetch(`editDriverDetails/${DriverID}`, {
      method: "PUT",
      body: JSON.stringify(driverData), // Send complete driver data including DriverID
    }),
    {
      loading: "Updating bus driver...",
      success: (data) => `${data.message}`,
      error: "Failed to update bus driver",
    }
  );
};

export const getDriverDetailData = async () => {
  try {
    const response = await customFetch("driverandroutes", {
      method: "GET",
    });
    return response ? response?.data : []; // Return an empty array if response is not valid
  } catch (error) {
    console.error("Error fetching emirates:", error);
    throw error;
  }
};

export const getDriverDetailDatawithTime = async (driverId, routeId) => {
  try {
    const queryParams = new URLSearchParams({
      driverId: driverId ?? "", // fallback to empty string if null/undefined
      routeId: routeId ?? "",
    }).toString();

    const response = await customFetch(`driverandrouteswithtime?${queryParams}`, {
      method: "GET",
    });

    return response ? response?.data : [];
  } catch (error) {
    console.error("Error fetching driver details with time:", error);
    throw error;
  }
};

// ====================== NEW: Upload Driver Image ======================
// We create a separate function that bypasses the problematic Content-Type
export const uploadDriverImage = async (file, employeeCode) => {
  const formData = new FormData();
  formData.append("image", file); // key must match backend: upload.single('image')

  return toast.promise(
    fetch(`${process.env.REACT_APP_BASE_API_URL}upload`, {
      // using same base URL
      method: "POST",
      body: formData,
      // Do NOT set Content-Type → browser will add correct multipart boundary
      headers: {
        "ngrok-skip-browser-warning": "true",
        // Add Authorization if you need token
        ...(localStorage.getItem("token") && {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }),
      },
    }).then(async (response) => {
      const contentType = response.headers.get("content-type");
      let data;

      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      } else {
        data = await response.text();
      }

      if (!response.ok) {
        throw new Error(data.message || "Upload failed");
      }

      return data;
    }),
    {
      loading: "Uploading driver photo...",
      success: (data) => {
        if (data.success) return "Driver photo uploaded successfully!";
        throw new Error(data.message || "Upload failed");
      },
      error: (err) => err.message || "Failed to upload photo",
    }
  );
};
